<div class="container-fuid content-temp">
    <div class="main">        
    </div>
</div>